'use client'

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/Carousel';
import { webbedFormatHotel } from '@/components/hotels/utils/webbedFormatHotel';
import WebbedHotelSquareCardV2 from '@/components/hotels/WebbedHotelSquareCardV2';
import { WebbedHotel } from '@/types/webbeds';
import getNextDate from '@/utils/getNextDay';
import Cookies from 'js-cookie';
export default function HotelsList({ initialHotels }: { initialHotels: WebbedHotel[], hotelImageBase?: string }) {

    const currency = Cookies.get('currency') || 'USD'

    return (
        <div>
            <div className='my-slider-container mt-4'>

                { initialHotels.length > 0 ?
                    <Carousel className="w-full">
                        <CarouselContent className='pl-3'>
                            {initialHotels?.map((hotel: WebbedHotel, index) => {
                                const formattedHotel = webbedFormatHotel(hotel, 2, currency);

                                return (
                                    <CarouselItem key={hotel.id}
                                        className="md:px-2 !basis-1/6 min-w-[208px] md:w-full 
                                                    !w-[208px] sm:w-full  px-0.5 !h-full first:pl-4 
                                                    sm:first:pl-2
                                                    ">
                                        <WebbedHotelSquareCardV2
                                            navigateTo={formattedHotel.navigateTo({
                                                start: getNextDate(0),
                                                end: getNextDate(1),
                                            })}
                                            hotel={formattedHotel}
                                            key={hotel.id}
                                        />
                                    </CarouselItem>
                                );
                            })}
                        </CarouselContent>
                        <CarouselPrevious className=' hidden md:block backdrop-blur' />
                        <CarouselNext className=' hidden md:block backdrop-blur' />
                    </Carousel>
                    : <div className='min-h-[240px] w-full h-[240px] flex items-center justify-center'>
                        <p>No Hotel Was Found!</p>
                    </div> }
            </div>
        </div >
    );
}